module.exports = __webpack_public_path__ + "static/media/badge_level_3_2.408f560d.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_level_3_2.png
// module id = 502
// module chunks = 0